import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ITag, RootState } from 'constants/interfaces'
import keys from 'constants/keys'
import { getTaskAudience } from 'redux/actions/tasks_v2'

type GetTaskAudienceArgs = {
  groups?: string[]
  users?: string[]
  tags?: string[]
  is_individual_results: boolean
  view?: number
  retailTags?: ITag[]
}

export const useGetTaskAudience = () => {
  const {
    groups: groupsObject,
    tags: configRetailTags,
    perm_groups_by_ft: permittedGroupsByFeature,
  } = useSelector((state: RootState) => state.config.config)
  const { groups: permittedGroups, users: permittedUsers } = useSelector(
    (state: RootState) => state.config.userWriteTaskPermissions
  )
  const permittedGroupIds = useMemo(() => Object.keys(permittedGroups || {}), [permittedGroups])

  return useCallback(
    ({ groups = [], users = [], tags = [], is_individual_results, view, retailTags }: GetTaskAudienceArgs) =>
      getTaskAudience({
        retailTags: retailTags || configRetailTags || [],
        groups,
        users,
        tags,
        is_individual_results,
        groupsObject: groupsObject || {},
        isVM: view === keys.DEFAULT_TASK_VIEWS.VM,
        permittedGroupIds,
        permittedUserIds: permittedUsers,
        permittedGroupsByFeature,
      }),
    [configRetailTags, groupsObject, permittedGroupIds, permittedGroupsByFeature, permittedUsers]
  )
}
